import { registerPlugin } from '@capacitor/core';
import type { BarcodeScannerPlugin } from '@capacitor-community/barcode-scanner';

const BarcodeScanner = registerPlugin<BarcodeScannerPlugin>('BarcodeScanner');

export * from '@capacitor-community/barcode-scanner/dist/esm/definitions';
export { BarcodeScanner };
